import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ymscmohrultolwhxwmhv.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inltc2Ntb2hydWx0b2x3aHh3bWh2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQyNjczOTcsImV4cCI6MjAxOTg0MzM5N30.mI1dq1evIG4J2kfsROcfaVvT7yCSuDP59wxPinAJ7sk';

export const supabase = createClient(supabaseUrl, supabaseKey);